// 注册一些自定义工具组件等
import tableList from "./table-list";
import BigNumber from "bignumber.js";
import { showErrorMessage } from "@/basa/utils/public";
import { dataURLtoFile, watermark } from "@/basa/utils/public";
// import VueMatomo from "vue-matomo";
// import router from "../../basa/router"; //多功能表格缓存名称
// import { addUrlPerFix } from "@/basa/utils";
export default {
  install: (Vue, options) => {
    Vue.prototype.tableList = tableList;
    Vue.prototype.$bus = new Vue();
    Vue.prototype.$BigNumber = BigNumber;
    Vue.prototype.$showErrorMessage = showErrorMessage;
    Vue.prototype.$dataURLtoFile = dataURLtoFile;
    Vue.prototype.$watermark = watermark;
    // 访问量所需插件注册
    // Vue.use(VueMatomo, {
    //   host: addUrlPerFix(process.env.VUE_APP_VUEMATOMO_HOST), // 这里配置你自己的piwik服务器地址和网站ID
    //   siteId: 6, //siteId值
    //   // 根据router自动注册
    //   router: router,
    //   // // 是否需要在发送追踪信息之前请求许可
    //   // // 默认false
    //   requireConsent: false,
    //   enableLinkTracking: true,
    //   // // 是否追踪初始页面
    //   // // 默认true
    //   trackInitialView: false,
    //   // // 最终的追踪js文件名
    //   // // 默认 'piwik'
    //   trackerFileName: "matomo",
    //   debug: false
    // });
  }
};
